import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotRecommend from './components/HotRecommend';
import CategorySection from './components/CategorySection';
import LatestUpdate from './components/LatestUpdate';
import { Link } from 'react-router-dom';
import { siteStats, faqList } from '@/mocks/manga';

export default function Home() {
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "亲亲漫画",
    "url": "https://qinqinmanga.com/",
    "description": "亲亲漫画按地域精选韩漫、日漫、国漫热门推荐，海量免费漫画在线全集下拉式阅读。",
    "contactPoint": {
      "@type": "ContactPoint",
      "email": "contact@qinqinmanga.com",
      "contactType": "customer service",
      "availableLanguage": ["Chinese"]
    }
  };

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "亲亲漫画 - 免费全集下拉式在线漫画大全",
    "description": "亲亲漫画按地域精选韩漫、日漫、国漫热门推荐，海量免费漫画在线全集下拉式阅读。",
    "url": "https://qinqinmanga.com/",
    "isPartOf": {
      "@type": "WebSite",
      "name": "亲亲漫画",
      "url": "https://qinqinmanga.com/"
    }
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqList.slice(0, 5).map((faq) => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer,
      },
    })),
  };

  return (
    <>
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
    />
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
    />
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
    />
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />

        <section className="py-8 bg-background-50 border-b border-background-200/70">
          <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              <div className="text-center p-4">
                <div className="text-2xl md:text-3xl font-heading text-primary-500">{siteStats.totalManga.toLocaleString()}+</div>
                <p className="text-xs text-foreground-500 mt-1">漫画资源</p>
              </div>
              <div className="text-center p-4">
                <div className="text-2xl md:text-3xl font-heading text-accent-500">{siteStats.dailyUpdate}+</div>
                <p className="text-xs text-foreground-500 mt-1">每日更新</p>
              </div>
              <div className="text-center p-4">
                <div className="text-2xl md:text-3xl font-heading text-secondary-500">{(siteStats.totalUsers / 10000).toFixed(0)}万+</div>
                <p className="text-xs text-foreground-500 mt-1">注册用户</p>
              </div>
              <div className="text-center p-4">
                <div className="text-2xl md:text-3xl font-heading text-primary-500">{(siteStats.monthlyActive / 10000).toFixed(0)}万+</div>
                <p className="text-xs text-foreground-500 mt-1">月活用户</p>
              </div>
            </div>
          </div>
        </section>

        <HotRecommend />
        <CategorySection />
        <LatestUpdate />

        <section className="py-10 md:py-14 bg-background-100">
          <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
            <div className="text-center mb-8">
              <h2 className="text-xl md:text-2xl font-heading text-foreground-950">常见问题</h2>
              <p className="text-sm text-foreground-500 mt-1">关于亲亲漫画的常见疑问解答</p>
            </div>
            <div className="max-w-3xl mx-auto space-y-3">
              {faqList.map((faq, index) => (
                <details key={index} className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden">
                  <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                    <span className="text-sm font-medium text-foreground-800 pr-4">{faq.question}</span>
                    <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 text-foreground-400 group-open:rotate-180 transition-transform duration-200">
                      <i className="ri-arrow-down-s-line"></i>
                    </span>
                  </summary>
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14 bg-accent-500">
          <div className="max-w-screen-2xl mx-auto px-4 md:px-6 text-center">
            <h2 className="text-xl md:text-2xl font-heading text-background-50 mb-3">
              开始你的漫画之旅
            </h2>
            <p className="text-sm text-background-50/80 mb-6 max-w-lg mx-auto">
              海量韩漫日漫国漫，免费全集下拉式阅读，每日不间断更新
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center">
              <Link
                to="/category/remen"
                className="px-8 py-3 bg-background-50 text-primary-500 font-semibold rounded-lg hover:bg-background-100 transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-fire-line mr-2"></i>热门推荐
              </Link>
              <Link
                to="/about"
                className="px-8 py-3 bg-accent-600 hover:bg-accent-700 text-background-50 font-semibold rounded-lg transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-information-line mr-2"></i>了解更多
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
    </>
  );
}